module.exports = __webpack_public_path__ + "img/icono-volver.2522536c.svg";